module.exports = __webpack_public_path__ + "static/media/businesses-icon-4.5879cb5e.svg";